import { useMedia } from "react-use";
import { breakpoints } from "@vfit/shared/themes";
export function useMediaQuery(breakpoint, logic) {
    var query = "(".concat(logic, "-width: ").concat(breakpoints[breakpoint], ")");
    return useMedia(query);
}
